<section class="sen-own-panel">
    <p class="my-2">{{translate.getLng('MOD_PICK_OWN_HELP')}}</p>
    <div  *ngIf="sol30Modal" class="alert alert-success" role="alert" style="display: flex;justify-content: space-between;align-items: center;">
        <div class="moveKey">{{ translate.getLng("SOL30_FRAME_30MM_ONLY") }}</div>
        <button type="button"      
            class="close" (click)="sol30ModalClose()" data-dismiss="alert" aria-label="Close" style="position: relative;top: -6px; left: 6px;">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <section [formGroup]="form" fxLayout="row">
        <section fxFlex="1 1 60%" class="mb-2">
            <div fxLayout="row wrap" fxLayoutAlign="flex-start center">
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('PRODUCER')}}</mat-label>
                    <input matInput formControlName="manufacturer">
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('NAME')}}</mat-label>
                    <input matInput formControlName="name">
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('WIDTH')}}</mat-label>
                    <input matInput mask="0000" formControlName="width">
                    <mat-hint align="end" *ngIf="formControls.width.errors">{{translate.getLng('MIN')}}:
                        {{global.PANEL_SIZE_MIN}},
                        {{translate.getLng('MAX')}}: {{global.PANEL_SIZE_MAX}}
                    </mat-hint>
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('HEIGHT')}}</mat-label>
                    <input matInput mask="0000" formControlName="height">
                    <mat-hint align="end" *ngIf="formControls.height.errors">{{translate.getLng('MIN')}}:
                        {{global.PANEL_SIZE_MIN}},
                        {{translate.getLng('MAX')}}: {{global.PANEL_SIZE_MAX}}
                    </mat-hint>
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('CELL_TECH')}}</mat-label>
                    <mat-select formControlName="type">
                        <mat-option *ngFor="let t of cellType" [value]="t.value">{{t.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('THICKNESS')}}</mat-label>
                    <input matInput mask="00" formControlName="thickness">
                    <mat-hint align="end" *ngIf="formControls.thickness.errors">{{translate.getLng('MIN')}}:
                        {{global.PANEL_THICK_MIN}},
                        {{translate.getLng('MAX')}}: {{global.PANEL_THICK_MAX}}
                    </mat-hint>
                </mat-form-field>
                <!-- <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('POWER')}}</mat-label>
                    <input matInput mask="0000000000" formControlName="power">
                </mat-form-field> -->
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('ICOEFF')}}</mat-label>
                    <input matInput [dropSpecialCharacters]="false" mask="{{maskPattern}}" formControlName="Icoeff">
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('VCOEFF')}}</mat-label>
                    <input matInput [prefix]="'-'" [dropSpecialCharacters]="false" mask="{{maskPattern}}"
                        formControlName="Vcoeff">
                </mat-form-field>

                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('VOC')}}</mat-label>
                    <input matInput [dropSpecialCharacters]="false" mask="{{maskPattern}}" (input)="checkVoltage()"
                        formControlName="Voc">
                    <mat-hint align="end" *ngIf="formControls.Voc.errors">{{translate.getLng('VOC')}} &gt;
                        {{translate.getLng('VPM')}}
                    </mat-hint>
                </mat-form-field>

                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('VPM')}}</mat-label>
                    <input matInput [dropSpecialCharacters]="false" mask="{{maskPattern}}" (input)="checkVoltage()"
                        formControlName="Vpm">
                    <mat-hint align="end" *ngIf="formControls.Voc.errors">{{translate.getLng('VPM')}} &lt;
                        {{translate.getLng('VOC')}}
                    </mat-hint>
                </mat-form-field>

                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('VSYS')}}</mat-label>
                    <input matInput mask="0000000000" formControlName="Vsys">
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('PDC')}}</mat-label>
                    <input matInput mask="0000000000" formControlName="Pdc">
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('ISC')}}</mat-label>
                    <input matInput [dropSpecialCharacters]="false" mask="{{maskPattern}}" (input)="checkCurrent()"
                        formControlName="Isc">
                    <mat-hint align="end" *ngIf="formControls.Isc.errors">{{translate.getLng('ISC')}} &gt;
                        {{translate.getLng('IPM')}}
                    </mat-hint>
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('IPM')}}</mat-label>
                    <input matInput (input)="checkCurrent()" [dropSpecialCharacters]="false" mask="{{maskPattern}}"
                        formControlName="Ipm">
                    <mat-hint align="end" *ngIf="formControls.Isc.errors">{{translate.getLng('IPM')}} &lt;
                        {{translate.getLng('ISC')}}
                    </mat-hint>
                </mat-form-field>
                <mat-form-field class="sen-w-45 mx-2">
                    <mat-label>{{translate.getLng('IREVERSE')}}</mat-label>
                    <input matInput mask="0000000000" formControlName="Ireverse">
                </mat-form-field>
                <mat-checkbox formControlName="landscape" class="sen-w-45 mx-2"> {{translate.getLng('LANDSCAPE')}}
                </mat-checkbox>
                <div class="sen-w-45 mx-2">
                    <mat-checkbox [(ngModel)]="projectPanel" (ngModelChange)="setUserPanelSelected()"
                        [ngModelOptions]="{standalone: true}" [disabled]="projectPanelDisable">
                        {{translate.getLng('PROJECT_PANEL')}}</mat-checkbox>
                    <mat-icon matTooltipClass="sen-snackbar-color"
                        matTooltip="{{translate.getLng('PROJECT_PANEL_MESSAGE')}}"
                        class="sen-fs14 ml-2 sen-cursor-pointer" color="primary">info</mat-icon>
                </div>
                <div class="sen-w-45 mx-2">
                    <button (click)="addCustomPanel()" mat-raised-button color="primary" class="float-right mx-2 mb-2">
                        {{translate.getLng('SAVE')}}
                    </button>
                    <button (click)="clearForm()" class="sen-secondary-icon bg-white mx-2 float-right mb-2" mat-fab>
                        <mat-icon class="mb-2">add</mat-icon>
                    </button>
                </div>
            </div>
        </section>
        <section fxFlex="1 1 40%">
            <div class="sen-info-color-bg p-3 mb-2">
                <table #customPanelList mat-table class="h-100 w-100" [dataSource]="dataSource">
                    <ng-container matColumnDef="manufacturer">
                        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('PRODUCER')}} </th>
                        <td mat-cell *matCellDef="let element" title="{{element.manufacturer}}">
                            {{element.manufacturer | truncate:10}} </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('NAME')}} </th>
                        <td mat-cell *matCellDef="let element" title="{{element.name}}"> {{element.name | truncate:10}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-icon (click)="removePanel($event, element)"
                                class="sen-active-color pt-2 sen-cursor-pointer sen-fs16">delete</mat-icon>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="sen-cursor-pointer" mat-row (click)="getPanelDetails(row)"
                        *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </section>
    </section>
   
</section>